export const SHIPMENT_COMMENT_TAB = {
  note: 'note',
  task: 'task',
  phone: 'phone',
  email: 'email',
  file: 'file',
  contract: 'contract',
  payment: 'payment',
} as const

export type ShipmentCommentTab =
  (typeof SHIPMENT_COMMENT_TAB)[keyof typeof SHIPMENT_COMMENT_TAB]
